/* bl-menu.js — Umschalter Shop | Learn im mobilen Drawer (Menü-Redesign 22.09.2026).
   Bewusst klein: kein Framework, keine Abhängigkeit vom Theme-JS. Die Suche
   übernimmt der normale Shop-Suchschlitz, sobald jemand Enter drückt. */
(function () {
  function init(root) {
    if (!root || root.dataset.blMenuReady === '1') return;
    root.dataset.blMenuReady = '1';

    var tabs = root.querySelectorAll('[data-bl-tab]');
    var panes = root.querySelectorAll('[data-bl-pane]');

    function show(name) {
      tabs.forEach(function (t) {
        t.setAttribute('aria-selected', t.dataset.blTab === name ? 'true' : 'false');
      });
      panes.forEach(function (p) {
        if (p.dataset.blPane === name) { p.removeAttribute('hidden'); }
        else { p.setAttribute('hidden', ''); }
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.dataset.blTab); });
    });

    /* Die schwebende Logo-Leiste liegt ueber dem Drawer. Statt oben pauschal Platz
       zu reservieren, messen wir ihre Unterkante und setzen genau so viel Abstand —
       darunter laeuft die Liste beim Scrollen hinter die Leiste. (24.10.2026) */
    function kopfAbstand() {
      var leiste = document.querySelector('.mobile-header-parent');
      if (!leiste) return;
      var unten = Math.round(leiste.getBoundingClientRect().bottom);
      if (unten > 40 && unten < 320) root.style.setProperty('--bl-mt', (unten + 12) + 'px');
    }
    kopfAbstand();
    setTimeout(kopfAbstand, 300);
    window.addEventListener('resize', kopfAbstand);
    window.addEventListener('orientationchange', kopfAbstand);
    root.addEventListener('click', kopfAbstand);

    /* Unterzeilen-Variante zum Vergleichen: ?sub=b blendet alles aus, was nur
       in Variante A steht. Reine DEV-Hilfe für die Entscheidung. */
    try {
      if (/[?&]sub=b\b/i.test(window.location.search)) root.classList.add('bl-var-b');
    } catch (e) {}

    var search = root.querySelector('[data-bl-search]');
    if (search) {
      search.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        var q = search.value.trim();
        if (!q) return;
        e.preventDefault();
        window.location.href = '/search?q=' + encodeURIComponent(q);
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-bl-menu]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Der Drawer wird vom Theme nachgeladen/umgehängt — deshalb noch einmal beobachten.
  new MutationObserver(boot).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ------------------------------------------------------------------
   Menue-Tracking (24.10.2026, Wunsch Lucius: was klicken Leute im Menue,
   wie bewegen sie sich darin?)

   Ziele: GA4 ueber gtag (G-X39PG9EQYR, zusaetzlich GTM GT-5797X4D) und
   Microsoft Clarity. Beides liegt ohnehin auf jeder Seite; faellt eines
   aus, laeuft das andere weiter und die Seite merkt nichts davon.

   Ereignisse
     bl_menu_auf        Panel/Drawer geoeffnet            flaeche, geraet
     bl_menu_klick      Klick auf einen Eintrag           flaeche, bereich, ziel, pfad, position, geraet
     bl_menu_tab        Umschalter mobil Shop | Learn     flaeche (= Ziel-Reiter), geraet
     bl_menu_suche      Clean-Facts-Suche im Menue        begriff, geraet
     bl_menu_ohne_klick Panel wieder zu, nichts geklickt  flaeche, sekunden, geraet

   Parameternamen bewusst ohne Umlaute — GA4 nimmt nur a-z, 0-9 und _.
   ------------------------------------------------------------------ */
(function () {
  var AUF = {};            /* flaeche -> Zeitpunkt des Oeffnens */
  var GEKLICKT = {};       /* flaeche -> true, sobald etwas geklickt wurde */
  var GESCROLLT = {};      /* flaeche:marke -> true, damit jede Marke einmal zaehlt */

  function geraet() {
    return window.matchMedia('(max-width:989px)').matches ? 'mobil' : 'desktop';
  }

  function kurz(text, max) {
    return (text || '').replace(/\s+/g, ' ').trim().slice(0, max || 80);
  }

  function senden(name, daten) {
    daten = daten || {};
    daten.geraet = daten.geraet || geraet();
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, daten);
    } catch (e) {}
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', name);
        if (daten.ziel) window.clarity('set', 'bl_menu_ziel', String(daten.ziel));
      }
    } catch (e) {}
  }

  /* Welche Flaeche? .bl-mm--shop / .bl-mm--learn auf dem Desktop, im mobilen
     Drawer der gerade sichtbare Reiter. */
  function flaecheVon(el) {
    if (el.closest('.bl-mm--shop')) return 'shop';
    if (el.closest('.bl-mm--learn')) return 'learn';
    var pane = el.closest('[data-bl-pane]');
    if (pane) return 'mobil-' + pane.dataset.blPane;
    if (el.closest('.bl-mobbar')) return 'mobil-leiste';
    if (el.closest('#site-nav--mobile')) return 'mobil';
    if (el.closest('main-header, #site-header')) return 'kopf';
    return 'sonst';
  }

  /* Welcher Bereich innerhalb der Flaeche? Erst feste Rollen, dann die
     Gruppenueberschrift darueber (Menuetitel, also nichts hartkodiert). */
  function bereichVon(el) {
    if (el.closest('.bl-spot')) return 'spotlight';
    /* Reihenfolge zaehlt: „Alle Clean Facts" und „Alle Blogbeitraege" tragen
       ebenfalls .bl-btn (dieselbe Roll-Schaltflaeche). Erst die besonderen
       Rollen pruefen, sonst landet alles unter „alle-produkte". */
    if (el.classList.contains('bl-cf-cta') || el.classList.contains('bl-cfall')) return 'clean-facts-alle';
    if (el.classList.contains('bl-blog-cta') || el.classList.contains('bl-blogall')) return 'blog-alle';
    if (el.closest('.bl-cf-treffer')) {
      return el.classList.contains('bl-treffer-alle') ? 'clean-facts-alle' : 'clean-facts-treffer';
    }
    if (el.classList.contains('bl-cfhead')) return 'clean-facts-kopf';
    if (el.classList.contains('bl-thema') || el.classList.contains('bl-chip')) return 'clean-facts-thema';
    if (el.classList.contains('bl-util')) return 'service';
    if (el.classList.contains('bl-btn') || el.classList.contains('bl-allbtn')) return 'alle-produkte';
    if (el.closest('.bl-hero') || el.closest('.bl-small') || el.closest('.bl-bloghero')) return 'blog';
    if (el.closest('.bl-nav-list') || el.closest('.bl-mlist')) return 'loslegen';
    if (el.closest('.bl-mfoot')) return 'fusszeile';

    var col = el.closest('.bl-col');
    if (col) {
      var lbl = col.querySelector('.bl-lbl');
      if (lbl) return kurz(lbl.textContent, 40);
    }
    /* Mobil stehen die Gruppen flach untereinander — die letzte Ueberschrift
       oberhalb der Zeile ist die Gruppe. */
    var zeile = el.closest('.bl-mrow');
    if (zeile) {
      var v = zeile.previousElementSibling;
      while (v) {
        if (v.classList && v.classList.contains('bl-mlbl')) return kurz(v.textContent, 40);
        v = v.previousElementSibling;
      }
    }
    return 'sonst';
  }

  /* Beschriftung fuer den Bericht. Die Roll-Schaltflaechen des Themes tragen
     ihren Text dreimal (eine Mess-Ebene, zwei Hover-Ebenen) — sonst stuende in
     GA4 „Alle Produkte ansehen Alle Produkte ansehen Alle Produkte ansehen".
     Die Mess-Ebene .bl-roll__size traegt ihn genau einmal. Beim Spotlight faengt
     sie ausserdem die Schaltflaeche statt des ganzen Textblocks ab. */
  function zielVon(a) {
    var roll = a.querySelector('.bl-roll__size');
    if (roll) return kurz(roll.textContent, 80);
    var name = a.querySelector('.bl-prod-name, .bl-mrow-name, b');
    if (name) return kurz(name.textContent, 80);
    return kurz(a.textContent, 80);
  }

  function positionVon(el) {
    var zeile = el.closest('.bl-prod, .bl-mrow, .bl-nav-item, .bl-thema, .bl-chip') || el;
    var eltern = zeile.parentNode;
    if (!eltern) return 0;
    var gleiche = [].slice.call(eltern.children).filter(function (k) {
      return k.className === zeile.className;
    });
    return gleiche.indexOf(zeile) + 1;
  }

  /* Ein einziger Zuhoerer am Dokument — der Drawer wird vom Theme neu
     eingehaengt, einzeln gebundene Zuhoerer waeren danach weg. */
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href]');
    var tab = ev.target.closest && ev.target.closest('[data-bl-tab]');

    if (tab) {
      GESCROLLT = {};
      senden('bl_menu_tab', { flaeche: 'mobil-' + tab.dataset.blTab });
      return;
    }
    if (!a) return;
    if (!a.closest('.bl-mm, .bl-mob, main-header, #site-header, #site-nav--mobile')) return;

    var flaeche = flaecheVon(a);
    GEKLICKT[flaeche] = true;

    senden('bl_menu_klick', {
      flaeche: flaeche,
      bereich: bereichVon(a),
      ziel: zielVon(a),
      pfad: kurz((a.getAttribute('href') || '').split('?')[0], 100),
      position: positionVon(a)
    });
  }, true);

  /* Clean-Facts-Suche im Learn-Panel */
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f.classList || !f.classList.contains('bl-cf-search')) return;
    var feld = f.querySelector('input[name="q"], input[name="suche"]');
    senden('bl_menu_suche', { begriff: kurz(feld ? feld.value : '', 80) });
  }, true);

  function auf(flaeche) {
    if (AUF[flaeche]) return;
    AUF[flaeche] = Date.now();
    GEKLICKT[flaeche] = false;
    GESCROLLT = {};
    senden('bl_menu_auf', { flaeche: flaeche });
  }
  function zu(flaeche) {
    if (!AUF[flaeche]) return;
    var sek = Math.round((Date.now() - AUF[flaeche]) / 1000);
    if (!GEKLICKT[flaeche] && sek >= 1) {
      senden('bl_menu_ohne_klick', { flaeche: flaeche, sekunden: sek });
    }
    AUF[flaeche] = 0;
  }

  /* Desktop: das Panel gilt als geoeffnet, wenn der Zeiger mindestens eine
     Viertelsekunde auf dem Menuepunkt bleibt — sonst zaehlt jedes Vorbeifahren. */
  function desktopBeobachten() {
    ['shop', 'learn'].forEach(function (f) {
      var panel = document.querySelector('.megamenu.' + f + '_menu');
      if (!panel || panel.dataset.blTrack === '1') return;
      var punkt = panel.closest('li') || panel.parentNode;
      if (!punkt) return;
      panel.dataset.blTrack = '1';
      var timer = null;
      punkt.addEventListener('mouseenter', function () {
        timer = setTimeout(function () { auf(f); }, 250);
      });
      punkt.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        zu(f);
      });
    });
  }

  /* Mobil: der Drawer bekommt vom Theme die Klasse `active`. */
  function mobilBeobachten() {
    var drawer = document.getElementById('site-nav--mobile');
    if (!drawer || drawer.dataset.blTrack === '1') return;
    drawer.dataset.blTrack = '1';
    new MutationObserver(function () {
      var offen = drawer.classList.contains('active');
      /* Dieselbe Klasse steuert in bl-menu.css die Logo-Leiste: durchlaessig fuer
         Wischgesten und als Glas, solange der Drawer offen ist. */
      document.documentElement.classList.toggle('bl-drawer-auf', offen);
      if (offen) auf('mobil'); else zu('mobil');
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* Wie weit wird im mobilen Menue gescrollt? Je Oeffnung einmal pro Marke.
     Auf dem Desktop gibt es nichts zu messen: Das Panel hat eine feste Hoehe,
     es ist immer alles zu sehen. Dort sagen bl_menu_auf und bl_menu_ohne_klick,
     ob jemand etwas damit angefangen hat. */
  var MARKEN = [25, 50, 75, 100];
  function scrollBeobachten() {
    [].forEach.call(document.querySelectorAll('.bl-mob-pane'), function (pane) {
      if (pane.dataset.blScroll === '1') return;
      pane.dataset.blScroll = '1';
      pane.addEventListener('scroll', function () {
        var weg = pane.scrollHeight - pane.clientHeight;
        if (weg < 40) return;                      /* nichts zu scrollen */
        var prozent = Math.round((pane.scrollTop / weg) * 100);
        var flaeche = 'mobil-' + (pane.dataset.blPane || '');
        MARKEN.forEach(function (m) {
          var schluessel = flaeche + ':' + m;
          if (prozent >= m && !GESCROLLT[schluessel]) {
            GESCROLLT[schluessel] = true;
            senden('bl_menu_scroll', { flaeche: flaeche, tiefe: m });
          }
        });
      }, { passive: true });
    });
  }

  function start() { desktopBeobachten(); mobilBeobachten(); scrollBeobachten(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  new MutationObserver(start).observe(document.documentElement, { childList: true, subtree: true });
})();


/* ------------------------------------------------------------------
   Clean-Facts-Treffer direkt im Menue (24.10.2026, Idee Lucius).

   Wer im Learn-Panel tippt, sieht die passenden Fragen sofort und landet
   mit einem Tipp beim Artikel, statt erst auf die Uebersichtsseite zu gehen.
   Quelle sind Shopifys eigene Suchvorschlaege, gefiltert auf den Blog
   `clean-facts` — es wird also nichts mitgeschleppt, sondern erst beim
   ersten Tastendruck geholt. Enter fuehrt weiterhin auf die Seite.
   ------------------------------------------------------------------ */
(function () {
  var MAX = 5;
  var laeuft = null;
  var zwischenspeicher = {};

  function bauen(kasten, wort, treffer) {
    kasten.innerHTML = '';
    if (!treffer.length) {
      var leer = document.createElement('div');
      leer.className = 'bl-treffer-leer';
      leer.textContent = kasten.dataset.leer || '';
      kasten.appendChild(leer);
    } else {
      treffer.slice(0, MAX).forEach(function (t) {
        var a = document.createElement('a');
        a.href = t.url;
        a.textContent = t.title;
        kasten.appendChild(a);
      });
      var alle = document.createElement('a');
      alle.className = 'bl-treffer-alle';
      /* Auf die Shop-Suche, eingegrenzt auf Artikel — die Clean-Facts-Seite
         laesst sich von aussen nicht filtern (24.10.2026). */
      alle.href = '/search?type=article&q=' + encodeURIComponent(wort);
      alle.textContent = kasten.dataset.alle || '';
      kasten.appendChild(alle);
    }
    kasten.removeAttribute('hidden');
  }

  function suchen(feld, kasten) {
    var wort = (feld.value || '').trim();
    if (wort.length < 3) { kasten.setAttribute('hidden', ''); return; }
    if (zwischenspeicher[wort]) { bauen(kasten, wort, zwischenspeicher[wort]); return; }
    var url = '/search/suggest.json?q=' + encodeURIComponent(wort) +
              '&resources[type]=article&resources[limit]=10';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var alle = (((d.resources || {}).results || {}).articles) || [];
        /* Nur das Lexikon, nicht der Butt Blog. */
        var nur = alle.filter(function (a) { return (a.url || '').indexOf('/blogs/clean-facts/') >= 0; })
                      .map(function (a) { return { title: a.title, url: a.url.split('?')[0] }; });
        zwischenspeicher[wort] = nur;
        if ((feld.value || '').trim() === wort) bauen(kasten, wort, nur);
      })
      .catch(function () { kasten.setAttribute('hidden', ''); });
  }

  function anhaengen() {
    [].forEach.call(document.querySelectorAll('[data-bl-treffer]'), function (kasten) {
      if (kasten.dataset.blBereit === '1') return;
      var form = kasten.previousElementSibling;
      while (form && form.tagName !== 'FORM') form = form.previousElementSibling;
      var feld = form && form.querySelector('input[name="q"], input[name="suche"]');
      if (!feld) return;
      kasten.dataset.blBereit = '1';

      feld.addEventListener('input', function () {
        clearTimeout(laeuft);
        laeuft = setTimeout(function () { suchen(feld, kasten); }, 220);
      });
      feld.addEventListener('blur', function () {
        /* Kurz warten, sonst ist der Kasten weg, bevor der Klick ankommt. */
        setTimeout(function () { kasten.setAttribute('hidden', ''); }, 180);
      });
      feld.addEventListener('focus', function () {
        if (kasten.children.length && (feld.value || '').trim().length >= 3) kasten.removeAttribute('hidden');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', anhaengen);
  } else {
    anhaengen();
  }
  new MutationObserver(anhaengen).observe(document.documentElement, { childList: true, subtree: true });
})();
